import { Component, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Body } from './layout/body/body';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [CommonModule, Body],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  currentYear = new Date().getFullYear();
  showLayout = true;
  opened = true;
  protected readonly title = signal('const-insight-frontend');

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = (event as NavigationEnd).url;
        this.showLayout = !url.includes('login');
      });
  }
}
